// PhaseDot — 9-state subscription machine indicator.
// Always paired with a label (default from canonical bundle table,
// or override with the `label` prop).
// See preview/colors-phases.html.

export type Phase =
  | 'discovered'
  | 'kyc-submitted'
  | 'kyc-attested'
  | 'kyc-verified'
  | 'allocated'
  | 'signed'
  | 'purchased'
  | 'settled'
  | 'rejected'
  | 'refunded';

const DEFAULT_LABEL: Record<Phase, string> = {
  discovered: 'Discovered',
  'kyc-submitted': 'KYC submitted',
  'kyc-attested': 'Officer attested',
  'kyc-verified': 'KYC verified',
  allocated: 'Allocated',
  signed: 'Signed',
  purchased: 'Purchased',
  settled: 'Settled',
  rejected: 'Rejected',
  refunded: 'Refunded',
};

const TOKEN: Record<Phase, string> = {
  discovered: 'phase-discovered',
  'kyc-submitted': 'phase-pending',
  'kyc-attested': 'phase-attested',
  'kyc-verified': 'phase-verified',
  allocated: 'phase-allocated',
  signed: 'phase-allocated',
  purchased: 'phase-purchased',
  settled: 'phase-settled',
  rejected: 'phase-rejected',
  refunded: 'phase-refunded',
};

export type PhaseDotProps = {
  phase: Phase;
  label?: string;
  size?: 'sm' | 'md';
};

export function PhaseDot({ phase, label, size = 'sm' }: PhaseDotProps) {
  const dotSize = size === 'md' ? 'w-2.5 h-2.5' : 'w-2 h-2';
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-foreground">
      <span
        aria-hidden
        className={`inline-block ${dotSize} rounded-full`}
        style={{ background: `var(--${TOKEN[phase]})` }}
      />
      {label ?? DEFAULT_LABEL[phase]}
    </span>
  );
}
